(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picky-audience"] && !Shopify.designMode) return;
  try {
    
(() => {
  function activate(tab, moveFocus) {
    const section = tab.closest('[data-picky-tabs]');
    section.querySelectorAll('[role="tab"]').forEach(button => {
      const active = button === tab;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
      document.getElementById(button.getAttribute('aria-controls')).hidden = !active;
    });
    if (moveFocus) tab.focus();
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-picky-tabs] [role="tab"]');
    if (tab) activate(tab, false);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-picky-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
    let index = tabs.indexOf(tab);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = tabs.length - 1;
    else index = (index + (event.key === 'ArrowLeft' ? 1 : -1) + tabs.length) % tabs.length;
    activate(tabs[index], true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picky-drawer"]) return;
  try {
    
(() => {
  const drawer = document.getElementById('PickyCartDrawer');
  if (!drawer) return;
  let busy = false;
  let opener = null;
  const root = window.Shopify?.routes?.root || '/';
  const sectionId = drawer.dataset.sectionId;
  const status = drawer.querySelector('[data-pk-status]');
  const error = drawer.querySelector('[data-pk-error]');
  function open(trigger) {
    if (!drawer.open) {
      opener = trigger || document.activeElement;
      drawer.showModal();
      document.documentElement.classList.add('pk-cart-open');
    }
  }
  function setBusy(value) {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    drawer.querySelectorAll('[data-pk-quantity], [data-pk-quantity-input], [data-pk-extra], [name="checkout"]').forEach(el => el.disabled = value || el.dataset.pkFixedDisabled === 'true');
    status.textContent = value ? drawer.dataset.loading : '';
  }
  function showError(message) {
    error.textContent = message || drawer.dataset.error;
    error.hidden = false;
  }
  function replaceContent(html, focusKey) {
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pk-cart-content]');
    if (!next) throw new Error(drawer.dataset.error);
    drawer.querySelector('[data-pk-cart-content]').replaceWith(next);
    const count = next.dataset.count;
    document.querySelectorAll('.pk-cart-count').forEach(el => el.textContent = count);
    document.querySelectorAll('.pk-cart-link').forEach(el => el.setAttribute('aria-label', `${el.dataset.cartLabel || 'Cart'} ${count}`));
    if (focusKey && drawer.open) {
      const item = [...next.querySelectorAll('.pk-drawer-item')].find(el => el.dataset.lineKey === focusKey);
      (item?.querySelector('[data-pk-quantity-input]') || drawer.querySelector('[data-pk-close]')).focus({ preventScroll: true });
    }
  }
  async function refresh(focusKey) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    if (drawer.dataset.preview === 'true') url.searchParams.set('preview_theme_id', drawer.dataset.themeId);
    const response = await fetch(url.toString(), { cache: 'no-store' });
    if (!response.ok) throw new Error(drawer.dataset.error);
    replaceContent(await response.text(), focusKey);
  }
  const offers = { 3: { bar: 'wDn4', upsell: 'w3Lm' }, 5: { bar: '5ojr', upsell: 'mA0r' }, 8: { bar: 'BNGQ', upsell: 'SGze' } };
  const offerFor = quantity => offers[quantity >= 8 ? 8 : quantity >= 5 ? 5 : 3];
  function metadata(value) {
    if (!value) return null;
    try { return JSON.parse(new DOMParser().parseFromString(value, 'text/html').documentElement.textContent); }
    catch (_) { return null; }
  }
  async function requestCart(url, body) {
    const response = await fetch(url, { method: 'POST', headers: { Accept: 'application/json' }, body });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || drawer.dataset.error);
    return data;
  }
  async function mutate(url, body, focusKey) {
    const data = await requestCart(url, body);
    await refresh(focusKey);
    return data;
  }
  async function change(key, quantity) {
    if (busy || !Number.isInteger(quantity) || quantity < 0) return;
    error.hidden = true;
    setBusy(true);
    try {
      const row = [...drawer.querySelectorAll('.pk-drawer-item')].find(item => item.dataset.lineKey === key);
      const properties = Object.fromEntries(JSON.parse(row?.dataset.properties || '[]'));
      const main = metadata(properties.__kaching_bundles);
      const isMain = main?.main && main.deal === '_6O2';
      if (isMain && quantity > 0) quantity = Math.max(3, quantity);
      if (main?.upsell && quantity > 1) quantity = 1;
      const data = new FormData();
      data.set('id', key);
      data.set('quantity', String(quantity));
      if (isMain && quantity > 0) {
        main.bid = offerFor(quantity).bar;
        properties.__kaching_bundles = JSON.stringify(main);
        Object.entries(properties).forEach(([name, value]) => data.set(`properties[${name}]`, value));
      }
      const cart = await requestCart(root + 'cart/change.js', data);
      if (isMain) {
        for (const item of cart.items) {
          const linked = metadata(item.properties?.__kaching_bundles);
          if (!linked?.upsell || linked.id !== main.id || linked.deal !== main.deal) continue;
          const update = new FormData();
          update.set('id', item.key);
          update.set('quantity', quantity === 0 ? '0' : String(item.quantity));
          if (quantity > 0) {
            linked.upsell = offerFor(quantity).upsell;
            const nextProperties = { ...item.properties, __kaching_bundles: JSON.stringify(linked) };
            Object.entries(nextProperties).forEach(([name, value]) => update.set(`properties[${name}]`, value));
          }
          await requestCart(root + 'cart/change.js', update);
        }
      }
      await refresh();
    } catch (e) {
      try { await refresh(key); } catch (_) { }
      showError(e.message);
    }
    finally { setBusy(false); status.textContent = error.hidden ? drawer.dataset.updated : ''; }
  }
  document.addEventListener('click', async event => {
    const cartLink = event.target.closest('.pk-cart-link');
    if (cartLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      open(cartLink);
      if (busy) return;
      error.hidden = true;
      setBusy(true);
      try { await refresh(); } catch (e) { showError(e.message); } finally { setBusy(false); }
    }
    if (event.target.closest('[data-pk-close]')) drawer.close();
    const extra = event.target.closest('[data-pk-extra]');
    if (extra && drawer.contains(extra) && !busy) {
      error.hidden = true;
      setBusy(true);
      try {
        const decoded = new DOMParser().parseFromString(extra.dataset.bundle, 'text/html').documentElement.textContent;
        const main = JSON.parse(decoded);
        const metadata = { id: main.id, deal: main.deal, v: main.v, upsell: offerFor(Number(extra.dataset.quantity)).upsell };
        const data = new FormData();
        data.set('id', extra.dataset.variant);
        data.set('quantity', '1');
        data.set('properties[__kaching_bundles]', JSON.stringify(metadata));
        await mutate(root + 'cart/add.js', data);
      } catch (e) {
        try { await refresh(); } catch (_) { }
        showError(e.message);
      } finally { setBusy(false); }
      return;
    }
    const button = event.target.closest('[data-pk-quantity]');
    if (button && drawer.contains(button)) change(button.closest('[data-line-key]').dataset.lineKey, Number(button.dataset.pkQuantity));
  });
  function commitQuantity(event) {
    const input = event.target.closest('[data-pk-quantity-input]');
    if (input && input.value !== input.defaultValue && !busy) {
      if (input.value.trim() === '' || !input.validity.valid) {
        input.value = input.defaultValue;
        return;
      }
      change(input.closest('[data-line-key]').dataset.lineKey, Number(input.value));
    }
  }
  drawer.addEventListener('change', commitQuantity, true);
  drawer.addEventListener('focusout', commitQuantity, true);
  drawer.addEventListener('click', event => {
    if (event.target === drawer) {
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) drawer.close();
    }
  });
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('pk-cart-open');
    if (opener?.isConnected) opener.focus({ preventScroll: true });
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.pk-product-form')) return;
    event.preventDefault();
    if (busy) return;
    const submit = form.querySelector('[name="add"]');
    open(submit);
    error.hidden = true;
    const body = new FormData(form);
    body.delete('return_to');
    submit.disabled = true;
    setBusy(true);
    try { await mutate(root + 'cart/add.js', body); }
    catch (e) {
      try { await refresh(); } catch (_) { }
      showError(e.message);
    }
    finally { submit.disabled = false; setBusy(false); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picky-header"]) return;
  try {
    
document.addEventListener('click',event=>{if(event.target.closest('.pk-mobile-menu a')){const menu=event.target.closest('details');if(menu)menu.open=false;}});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.pk-mobile-menu[open]').forEach(menu=>menu.open=false);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["picky-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const thumb=event.target.closest('[data-picky-image]');if(!thumb)return;const gallery=thumb.closest('.pk-gallery');const image=gallery.querySelector('.pk-main-image');image.removeAttribute('srcset');image.src=thumb.dataset.pickyImage;image.alt=thumb.dataset.pickyAlt;gallery.querySelectorAll('[data-picky-image]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));});
(() => {
  const quantity = Number(new URLSearchParams(window.location.search).get('quantity'));
  const index = [3, 5, 8].indexOf(quantity);
  if (index < 0) return;
  const form = document.querySelector('.pk-product-form');
  if (!form) return;
  const choose = () => {
    const buttons = form.querySelectorAll('.kaching-bundles__bar-main');
    if (buttons.length !== 3) return false;
    buttons[index].click();
    return true;
  };
  if (choose()) return;
  const observer = new MutationObserver(() => { if (choose()) observer.disconnect(); });
  observer.observe(form, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
})();

  } catch(e) { console.error(e); }
})();
})();
